var _circle, _circle2, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 82.286,
    cy: 45.7137,
    r: 27.4286,
    fill: "#F0FF65",
    opacity: "var(--idle-opacity)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.286,
    cy: 45.7137,
    r: 27.4286,
    fill: "#FBB4CC",
    opacity: "var(--error-opacity)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 37,
    width: 72,
    height: 56,
    stroke: "#191919",
    strokeWidth: "var(--stroke-width, 2)",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 37H100V44.4286L64 68L28 44.4286V37Z",
    stroke: "#191919",
    strokeWidth: "var(--stroke-width, 2)",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3194 63L100 86.2262L100 93L28 93L28 86.2262L44.6794 63",
    stroke: "#191919",
    strokeWidth: "var(--stroke-width, 2)",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSend);
export default __webpack_public_path__ + "static/media/mail-send.25eb3ec55186aa82f1295ca1432f5ea8.svg";
export { ForwardRef as ReactComponent };